const actions = {
    FETCH_RESULT_SLIDES: 'FETCH_RESULT_SLIDES',
    FETCH_RESULT_SLIDE: 'FETCH_RESULT_SLIDE',
    RESET_RESULT_SLIDE: 'RESET_RESULT_SLIDE',

    fetchResultSlidesAction: (data) => {
        return {
            type: actions.FETCH_RESULT_SLIDES,
            data: data
        };
    },
    fetchResultSlideAction: (data) => {
        return {
            type: actions.FETCH_RESULT_SLIDE,
            data: data
        };
    },
    resetResultSlideFormAction: () => {
        return {
            type: actions.RESET_RESULT_SLIDE,
            data: null
        };
    }
};

export default actions;
